var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "headerTop",
      style: {
        height: _vm.pageSetup.titleHeight + "px",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.pageSetup.isBack,
              expression: "pageSetup.isBack",
            },
          ],
          staticClass: "lef",
        },
        [_c("i", { staticClass: "el-icon-arrow-left" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-title",
          style: {
            height: _vm.pageSetup.titleHeight + "px",
            "line-height": _vm.pageSetup.titleHeight + "px",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.pageSetup.name) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }